export class TrackEventActionSettings {
    static $inject = ['init'];
    constructor(init) {
        this.extras = {};
        Object.assign(this, init);
    }
}
